__turbopack_context__.v({
  "affiliated_logo_content": "HeroSubBanner-module-scss-module__pqWdRa__affiliated_logo_content",
  "asia_pacific": "HeroSubBanner-module-scss-module__pqWdRa__asia_pacific",
  "brochure_share_btn_container": "HeroSubBanner-module-scss-module__pqWdRa__brochure_share_btn_container",
  "content_container": "HeroSubBanner-module-scss-module__pqWdRa__content_container",
  "content_wrapper": "HeroSubBanner-module-scss-module__pqWdRa__content_wrapper",
  "course_name": "HeroSubBanner-module-scss-module__pqWdRa__course_name",
  "ctaPrimary": "HeroSubBanner-module-scss-module__pqWdRa__ctaPrimary",
  "download_br": "HeroSubBanner-module-scss-module__pqWdRa__download_br",
  "duration": "HeroSubBanner-module-scss-module__pqWdRa__duration",
  "el_line": "HeroSubBanner-module-scss-module__pqWdRa__el_line",
  "global_accred": "HeroSubBanner-module-scss-module__pqWdRa__global_accred",
  "global_text": "HeroSubBanner-module-scss-module__pqWdRa__global_text",
  "hidden": "HeroSubBanner-module-scss-module__pqWdRa__hidden",
  "img_container": "HeroSubBanner-module-scss-module__pqWdRa__img_container",
  "root": "HeroSubBanner-module-scss-module__pqWdRa__root",
  "share_icon": "HeroSubBanner-module-scss-module__pqWdRa__share_icon",
  "tooltip": "HeroSubBanner-module-scss-module__pqWdRa__tooltip",
  "ugc_ent": "HeroSubBanner-module-scss-module__pqWdRa__ugc_ent",
});
